module.exports = "<div class=\"tabs__button\" v-bind:class=\"activeClass\" v-on:click=\"onTabClick\">\n  <p class=\"tabs__button__label\">{{label}}</p>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/tabs/tab-button/index.html
// module id = it7H
// module chunks = 1